export interface AiSkillHeader {
  key: string
  label: string
  description: string
  connectorTypeId: number | null
}

export interface AiSkill extends AiSkillHeader {
  id: number
  content: string
  source: 'auto' | 'manual'
  enabled: boolean
  createdAt: string
  updatedAt: string
}

export interface CreateAiSkillDto {
  key: string
  label: string
  description: string
  content: string
  connectorTypeId?: number | null
  source?: 'auto' | 'manual'
}

export interface UpdateAiSkillDto {
  label?: string
  description?: string
  content?: string
  enabled?: boolean
}

export interface MinimalMessage {
  role: string
  content: string
}

export const emptyCreateAiSkillForm: CreateAiSkillDto = {
  key: '',
  label: '',
  description: '',
  content: '',
  connectorTypeId: undefined,
  source: 'manual',
}
